// @ts-nocheck
import React, { Component } from "react";
import { Image, View, TouchableOpacity } from "react-native";
import styles, { componentStyles } from "../theme/styles";
import TextView from "./TextView";
import { icons } from "../theme/icons";


class RatingBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rate: this.props.rate,

        }
    }

    render() {
        return <View style={[{ flexDirection: 'row', justifyContent: 'center' }, this.props.style]}>
            <TouchableOpacity onPress={() => {
                if (this.props.enable) {
                    this.setState({
                        rate: 1
                    })
                    this.props.onRate(1);
                }

            }}>
                <Image source={this.state.rate < 1 ? icons['star_empty'] : icons['star']} style={componentStyles.rateImage} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => {
                if (this.props.enable) {
                    this.setState({
                        rate: 2
                    })
                    this.props.onRate(2);
                }
            }}>
                <Image source={this.state.rate < 2 ? icons['star_empty'] : icons['star']} style={componentStyles.rateImage} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => {
                if (this.props.enable) {
                    this.setState({
                        rate: 3
                    })
                    this.props.onRate(3);
                }
            }}>
                <Image source={this.state.rate < 3 ? icons['star_empty'] : icons['star']} style={componentStyles.rateImage} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => {
                if (this.props.enable) {
                    this.setState({
                        rate: 4
                    })
                    this.props.onRate(4);
                }
            }}>
                <Image source={this.state.rate < 4 ? icons['star_empty'] : icons['star']} style={componentStyles.rateImage} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => {
                if (this.props.enable) {
                    this.setState({
                        rate: 5
                    })
                    this.props.onRate(5);
                }
            }}>
                <Image source={this.state.rate < 5 ? icons['star_empty'] : icons['star']} style={componentStyles.rateImage} />
            </TouchableOpacity>
        </View>;
    }
    componentWillReceiveProps(newprops) {
        this.setState({
            rate: newprops.rate,
        })
    }
}

export default RatingBar;
